<template>
<div>
    <div class="error_popup popup-desktop" v-if="isLoading" style="display:block;">
        <div class="error_box error-pop-desk">
            <img src="@/assets/images/info_icon_plan.png" loading="lazy" alt="" class="image-496">
            <div class="text-block-1101">Please wait...</div>
            <div class="text-block-1102">While we get current offer details!</div>
        </div>
    </div>
    <div class="error_popup popup-desktop" v-if="showMessage" style="display:block;">
        <div class="error_box error-pop-desk">
            <img src="@/assets/images/info_icon_plan.png" loading="lazy" alt="" class="image-496">
            <div class="text-block-1101">Currently we do not offer 12.5mg Dosages of Tirzepatide.</div>
            <div class="text-block-1102">Would you like to lock in our all industry low pricing for 10mg dosage of Tirzepatide?</div>
            <div class="button-model-yes-no">
                <a data-w-id="e171a656-b153-7c5c-2d27-5fb3734ada93" href="#" class="button-107 w-button" @click.prevent="active_el++">Yes</a>
                <a data-w-id="e171a656-b153-7c5c-2d27-5fb3734ada93" href="#" class="button-107 w-button" @click.prevent="moveToSorryPage()">No</a>
            </div>
        </div>
    </div>
    <section>
        <div class="top-nav-div">
            <div class="top-nav-elements reportform">
                <a href="#" class="link-block-42 form-rep w-inline-block">
                    <img sizes="84.03125px" srcset="@/assets/images/NewSelf_Logo-p-500.png 500w, @/assets/images/NewSelf_Logo-p-800.png 800w, @/assets/images/NewSelf_Logo.png 1000w" alt="" src="@/assets/images/NewSelf_Logo.png" loading="lazy" class="image-294 form-rep">
                </a>
            </div>
        </div>
    </section>
    <section class="afterreport_section form-rep">
        <div class="questions-div form-rep">
            <div class="question-container" v-if="active_el==1">
                <div class="question-div-2 form-rep">
                    <div class="text-block-513 form-rep">Do you currently take weight loss medication?<br></div>
                    <div class="felix-form-block form-rep top w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="6752fce89f545be422ca0525" data-wf-element-id="3416fdec-b089-e392-c3b8-07826e71b460">
                            <div class="div-block-1487">
                                <a href="#" class="button-68 w-button" @click.prevent="setValue('currentlyTakingGLP','Yes')">YES</a>
                                <a href="#" class="button-68 w-button" @click.prevent="setValue('currentlyTakingGLP','No')">NO</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="question-container form-rep" v-if="active_el==2">
                <div class="question-div-2 form-rep">
                    <div class="text-block-513 form-rep">What weight loss drugs are you currently prescribed?<br></div>
                    <div class="form-subs form-rep">Include drugs you have taken in the last 2 weeks only.</div>
                    <div class="felix-form-block form-rep w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-16" data-wf-page-id="6752fce89f545be422ca0525" data-wf-element-id="3abb582e-8853-a9ef-0290-ed0a78b0ffde">
                            <div class="rx_option_div">
                                <a href="#" class="link-block-76 w-inline-block" @click.prevent="setValue('currentGLPMed','Semaglutide')">
                                    <div class="text-block-1137">Semaglutide</div>
                                    <div class="text-block-1138">(Compound, Ozempic, or Wegovy)</div>
                                </a>
                                <a href="#" class="link-block-76 w-inline-block" @click.prevent="setValue('currentGLPMed','Tirzepatide')">
                                    <div class="text-block-1137">Tirzepatide</div>
                                    <div class="text-block-1138">(Compound, Mounjaro, Zepbound)</div>
                                </a>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="question-container form-rep" v-if="active_el==3">
                <div class="question-div-2 form-rep">
                    <div class="text-block-513 form-rep">What {{planOptions.currentGLPMed}} dosage are you currently taking?</div>
                    <div class="form-subs form-rep">We will send this to the doc to ensure you are sent the right dosing plan.</div>
                    <div class="felix-form-block form-rep w-form">
                        <form @submit.prevent="setPlan()">
                            <select required class="select-field-9 w-select" v-model="planOptions.currentDose">
                                <option value="">Select dose...</option>
                                <option v-for="d in doseOption" :key="d" :value="d">{{d}} mg</option>
                            </select>
                            <input type="submit" data-wait="Please wait..." class="form-button form-rep w-button" value="Next -&gt;">
                        </form>
                    </div>
                    <div class="div-block-1941">
                        <div class="text-block-1127"><span class="text-span-240">Same Price. All Dosage Levels.</span><br>No Hidden Fees. Everything Included.</div>
                        <div class="treatsum_deetsdiv form">
                            <div class="treatsum_inclusionsdiv form">
                                <div class="treatsum_perkdiv form-rep"><img src="@/assets/images/icon_board-copy.svg" loading="lazy" alt="" class="image-474 form-rep">
                                    <div class="text-block-1041 form-rep">Initial Telehealth Visit</div>
                                </div>
                                <div class="treatsum_perkdiv form-rep"><img src="@/assets/images/icon_meds-copy.svg" loading="lazy" alt="" class="image-474 form-rep">
                                    <div class="text-block-1041 form-rep">Prescription + Medication</div>
                                </div>
                            </div>
                            <div class="treatsum_inclusionsdiv form">
                                <div class="treatsum_perkdiv form-rep"><img src="@/assets/images/icon_support.svg" loading="lazy" alt="" class="image-474 form-rep">
                                    <div class="text-block-1041 form-rep">24/7 Support</div>
                                </div>
                                <div class="treatsum_perkdiv form-rep"><img src="@/assets/images/icon_appointment.svg" loading="lazy" alt="" class="image-474 form-rep">
                                    <div class="text-block-1041 form-rep">Monthly check-in</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="question-container form-rep" v-if="active_el==4">
                <div class="question-div-2 form-rep">
                    <div class="text-block-513 form-rep">Choose your medication:<br></div>
                    <div class="felix-form-block form-rep w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-16" data-wf-page-id="6752fce89f545be422ca0525" data-wf-element-id="b20b5e1b-d601-2e62-402f-e0e0f80c3f2f">
                            <div class="program-choice-div products">
                                <a href="#" class="link-block-48 tirz w-inline-block" @click.prevent="setValue('selectedGLPMed','Tirzepatide')">
                                    <div class="div-block-1643 tirz">
                                        <div class="text-block-719"><span class="text-span-174 tirz">Most Effective</span></div>
                                        <div class="form-product-2">Tirzepatide</div>
                                        <div class="text-block-724">COMPOUND</div>
                                        <p class="paragraph-126 report">Same active ingredient as <strong>Mounjaro® &amp; Zepbound®</strong></p>
                                        <div class="div-block-1949">
                                            <div>
                                                <div class="div-block-1948"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-508">
                                                    <div class="bullet-text-3 _2"><strong>Up to 22% </strong>Weight Loss*</div>
                                                </div>
                                                <div class="div-block-1948"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-508">
                                                    <div class="bullet-text-3 _2">Works on <strong>2</strong> GLP Receptors.</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">A once-weekly injection.</div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">Most Effective GLP-1</div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">Produced in the USA.</div>
                                        </div>
                                        <div class="text-block-1140">Starting at $195 a month.</div><input type="submit" data-wait="Please wait..." class="submit-button-7 w-button" value="Get Started">
                                    </div>
                                </a>
                                <a href="#" class="link-block-48 sema w-inline-block" @click.prevent="setValue('selectedGLPMed','Semaglutide')">
                                    <div class="div-block-1643 sema">
                                        <div class="text-block-719"><span class="text-span-174 sema">Most Popular</span></div>
                                        <div class="form-product-2">Semaglutide</div>
                                        <div class="text-block-724">COMPOUND</div>
                                        <p class="paragraph-126 report">Same active ingredient as <strong>Ozempic® &amp; Wegovy®</strong></p>
                                        <div class="div-block-1949">
                                            <div>
                                                <div class="div-block-1948"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-508">
                                                    <div class="bullet-text-3"><strong>Up to 16%</strong> Weight Loss</div>
                                                </div>
                                                <div class="div-block-1948"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-508">
                                                    <div class="bullet-text-3">Works on <strong>1 </strong>GLP Receptor</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">A once-weekly injection.</div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">Most Prescribed GLP-1 </div>
                                        </div>
                                        <div class="div-block-1645"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-370">
                                            <div class="text-block-713">Produced in the USA.</div>
                                        </div>
                                        <div class="text-block-1140">Starting at $130 a month.</div><input type="submit" data-wait="Please wait..." class="submit-button-7 w-button" value="Get Started">
                                    </div>
                                </a>
                            </div>
                            <div class="div-block-1503">
                                <!--<a href="#" class="link-40">Not sure which one?</a>-->
                            </div>
                        </form>

                    </div>
                </div>
            </div>
            <div class="question-container form-rep" v-if="active_el==5">
                <div class="question-div-2 form-rep">
                    <div class="text-block-513 form-rep">Select your billing plan<br></div>
                    <div class="form-subs form-rep">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div>
                    <div class="felix-form-block form-rep w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-16" data-wf-page-id="6752fce89f545be422ca0525" data-wf-element-id="5fde915b-2540-9e61-e12b-3064cde12cb6">
                            <div class="bill-plan-div">
                                <a href="#" class="bill-plan-link w-inline-block" @click.prevent="setValue('billingTerms',3)">
                                    <div class="text-block-1128">Quarterly</div>
                                    <div class="plan-bullets">
                                        <div class="planbullet"><img src="@/assets/images/icon_check-black2.svg" loading="lazy" alt="" class="image-504">
                                            <div class="text-block-1129"><span class="text-span-242">$130</span> a month</div>
                                        </div>
                                        <div class="planbullet"><img src="@/assets/images/icon_check-black2.svg" loading="lazy" alt="" class="image-504">
                                            <div class="text-block-1129"><span class="text-span-242">$390</span> Billed Quarterly</div>
                                        </div>
                                    </div>
                                    <div class="plan-save-div">
                                        <div class="text-block-1130">SAVE MORE!</div>
                                    </div>
                                </a>
                                <a href="#" class="bill-plan-link w-inline-block" @click.prevent="setValue('billingTerms',1)">
                                    <div class="text-block-1128">Monthly</div>
                                    <div class="plan-bullets">
                                        <div class="planbullet"><img src="@/assets/images/icon_check-black2.svg" loading="lazy" alt="" class="image-504">
                                            <div class="text-block-1129"><span class="text-span-242">$149.97</span> on month 1</div>
                                        </div>
                                        <div class="planbullet"><img src="@/assets/images/icon_check-black2.svg" loading="lazy" alt="" class="image-504">
                                            <div class="text-block-1129"><span class="text-span-242">$299.97</span> on each month after</div>
                                        </div>
                                    </div>
                                    <div class="text-block-1129 commit">(3-month commitment)</div>
                                </a>
                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div style="height:280px"></div>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';

import {
    getProductsByOffer
} from '@/utils/productData';

export default {
    components: {

    },
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            showMessage: false,
            active_el: 1,
            isLoading: false,
            planOptions: {
                currentlyTakingGLP: '',
                currentGLPMed: '',
                selectedGLPMed: '',
                selectedPlanTerms: '',
                currentDose: ''
            }
        }
    },
    computed: {
        doseOption() {
            if (this.planOptions.currentGLPMed === 'Semaglutide') {
                return [0.25, 0.5, 1, 2, 2.5];
            }
            return [2.5, 5, 7.5, 10, 12.5, 15];
        }
    },
    methods: {
        ...mapActions([
            'setCartVisibility',
            'clearCart'
        ]),
        setPlan() {
            if (this.planOptions.currentDose == null) {
                return false;
            }
            if(this.planOptions.currentDose > 10){
                this.showMessage=true;
            }else{
                this.planOptions.selectedGLPMed = this.planOptions.currentGLPMed;
                this.moveToCheckout();
            }
            
        },
        async setValue(field, value) {
            this.planOptions[field] = value;
            if (field === 'currentlyTakingGLP' && value === 'No') {
                this.moveNext(3);
            } else if (field === 'selectedGLPMed') {
                this.moveToCheckout();
            } else {
                this.moveNext(1);
            }
        },
        moveToSorryPage(){
            this.$router.push("/sorry?message=We're truly sorry to see you go. We'll notify you as soon as the doses are available.")
        },
        async moveToCheckout() {
            await this.clearCart();

            let plan = await this.getPlanByOffer();
            const cartItem = {
                id: plan.id,
                name: plan.name,
                category: plan.category.primary,
                price: plan.pricing.retail_price,
                retail_price: plan.pricing.retail_price,
                subheader: 'Compound Medication',
                sku: plan.sku,
                stripe_id: plan.stripe_id,
                quantity: 1, // Ensure it's a valid number
                image: `https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/product_image/webp/${plan.image_pre_text}/1.webp`,
                main_type: 1,
            };
            this.saveCart(cartItem);
        },
        getPlanByOffer() {
            try {
                let offer = this.$store.getters.offerTir;
                if(this.planOptions.selectedGLPMed==='Semaglutide'){
                    offer = this.$store.getters.offerSema;
                }
                let product = getProductsByOffer(offer);
                return product[0]
            } catch (error) {
                console.log("error getting product ", error.message)
            }
        },
        saveCart(cartItem) {
            this.isLoading = true;
            let postData = {
                ...cartItem,
                sema_offer: this.$store.getters.offerSema,
                tir_offer:this.$store.getters.offerTir, 
                currentGLPMed: this.planOptions.currentGLPMed,
                currentDose: this.planOptions.currentDose,
            };

            this.$axios.post(`${this.baseUrl}/forms/save-cart`, postData, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    if (response.data.status === 'success') {
                        this.$store.dispatch('addToCart', cartItem);
                        this.setCartVisibility(false);
                        this.$router.push({
                            name: 'checkoutWeightLoss',
                            params: {
                                cart_id: response.data.id
                            }
                        });
                        this.isLoading = false;
                    } else {
                        alert("Unexpected response:", response.data);
                    }
                })
                .catch(error => {
                    alert("Error saving cart:", error.message);
                });

        },
        moveNext(step) {
            console.log('offer from store ', this.$store.getters.weightLossOffer)
            this.active_el = this.active_el + step;

        },

    }
}
</script>
<style scoped>
.button-model-yes-no{
    display: flex;
    justify-content: space-around;
    gap: 15%;
    width:100%
}
.questions-div.form-rep {
        padding-top: 30px;
        padding-bottom: 50px;
        max-width: 100%;
        padding-left: 20px;
        padding-right: 20px;
}

.button-107{
    width: 45%
}

</style>